import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Heart, Mail } from "lucide-react";
import AaryaMark from "./AaryaMark";

// "About Aarya" bottom sheet.
export default function AboutSheet({ open, onClose }) {
  if (!open) return null;
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/50 z-50 flex items-end justify-center" onClick={onClose}
      >
        <motion.div
          initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "100%" }}
          transition={{ type: "spring", damping: 28, stiffness: 280 }}
          onClick={(e) => e.stopPropagation()}
          className="w-full max-w-[430px] max-h-[92dvh] bg-sand-50 rounded-t-[32px] flex flex-col"
          data-testid="about-sheet"
        >
          <div className="flex items-center justify-between px-6 pt-5 pb-3 border-b border-sand-200">
            <div className="flex items-center gap-3">
              <AaryaMark size={32}/>
              <div>
                <p className="font-display text-xl text-ink-900 leading-none">About Aarya</p>
                <p className="text-[10px] tracking-[0.18em] uppercase text-ink-500 mt-1">v1.0 · A gift from IndoBlitz</p>
              </div>
            </div>
            <button onClick={onClose} data-testid="about-close"
              className="h-9 w-9 rounded-full bg-white border border-sand-200 flex items-center justify-center">
              <X size={16}/>
            </button>
          </div>

          <div className="overflow-y-auto px-6 py-5 space-y-4">
            <div className="rounded-3xl bg-white border border-sand-200 p-5">
              <p className="text-[15px] text-ink-900 leading-relaxed">
                Aarya is a safety net for the family you love, wherever they live.
              </p>
              <p className="text-[13px] text-ink-500 mt-2 leading-relaxed">
                One tap to say &quot;I am safe&quot;. Hold the red bar for two seconds to send a silent SOS. That&apos;s the whole app. No feeds, no ads, no tracking, no drama.
              </p>
            </div>

            <div className="rounded-3xl bg-white border border-sand-200 p-5">
              <div className="flex items-center gap-2">
                <Heart size={16} className="text-terracotta-500"/>
                <p className="text-[13px] font-semibold text-ink-900">Why we built it</p>
              </div>
              <p className="text-[13px] text-ink-600 mt-2 leading-relaxed">
                Because our own parents live in one country and we live in another. Because a WhatsApp message every morning is exhausting for both sides. Because when something actually goes wrong, families deserve to know within seconds - not after hours of missed calls.
              </p>
            </div>

            <div className="rounded-3xl bg-white border border-sand-200 p-5">
              <p className="text-[13px] font-semibold text-ink-900">Built by IndoBlitz</p>
              <p className="text-[13px] text-ink-600 mt-2 leading-relaxed">
                IndoBlitz Private Limited is a legally registered company in India. Our team is small, our tools are open, and our accountability is real. Bobby Philips, founder, reads every email personally.
              </p>
              <img src="/indoblitz-logo.webp" alt="IndoBlitz" className="mt-3 h-8 w-auto opacity-70" draggable="false"/>
            </div>

            <div className="rounded-3xl bg-ink-900 text-white p-5">
              <div className="flex items-center gap-2">
                <Mail size={16}/>
                <p className="text-[13px] font-semibold">Talk to us</p>
              </div>
              <p className="text-[13px] leading-relaxed opacity-90 mt-2">
                Suggestions, bug reports, a story to share - write to
                {" "}<a href="mailto:admin@indoblitz.com" className="underline">admin@indoblitz.com</a>.
                A real human replies within 48 hours.
              </p>
              <p className="text-[11px] text-white/60 mt-3 tracking-wide">Aarya v1.0 · Cloud-hosted with love</p>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
